// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"wrapper-yCbOX","content":"content-iACRM","controls":"controls-3gV43"};